import React from 'react';
import OriginalOnlineBookings from '../marketing/OnlineBookings';

export default function OnlineBooking() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header - Dark theme */}
      <div className="bg-gray-900 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-white">Online Booking</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Original Content with wrapper */}
      <div className="bg-gray-100">
        <OriginalOnlineBookings />
      </div>
    </div>
  );
}



